import { FC, ReactElement } from 'react';

import { useUITranslation } from '@pp/core/src/services/uiTranslations/reactBindings/hooks';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { Textfit } from '../textfit/Textfit';

import { BUTTON_STATES, BUTTON_STATES_LABEL } from './types';

import styles from './FloatingGameBetButton.module.css';

interface FloatingGameBetButtonProps {
  buttonState: BUTTON_STATES;
  buttonLabel: BUTTON_STATES_LABEL;
  displayAmount: string;
  isDisabled: boolean;
  isLocalCashed: boolean;
  handleBetClick: (a: BUTTON_STATES) => void;
}
export const FloatingGameBetButton: FC<FloatingGameBetButtonProps> = ({
  buttonState,
  buttonLabel,
  displayAmount,
  isDisabled,
  isLocalCashed,
  handleBetClick,
}): ReactElement => {
  const buttonLabelUIT = useUITranslation(buttonLabel);
  const mods = useModifiers(
    styles,
    'floating_game_bet_button',
    {
      [buttonState]: true,
      localCashed: isLocalCashed,
      disabled: isDisabled,
    },
    {
      withBaseClass: true,
    }
  );

  return (
    <button className={mods} onClick={() => handleBetClick(buttonState)}>
      <div className={styles.floating_game_bet_button_label}>
        <Textfit offsetWidth={20}>{buttonLabelUIT}</Textfit>
      </div>
      <div className={styles.floating_game_bet_button_amount}>
        <Textfit offsetWidth={20}>{displayAmount}</Textfit>
      </div>
    </button>
  );
};
